import React from 'react';
import {
    FiZap,
    FiShield,
    FiActivity,
    FiCpu,
    FiDatabase,
    FiHeart,
    FiServer,
    FiCheckCircle,
    FiLock,
    FiSmartphone,
    FiGlobe,
    FiUsers,
    FiLayers,
    FiTrendingUp,
    FiAward,
    FiSettings,
    FiStar,
    FiClock,
    FiFileText,
    FiFolder,
    FiGrid,
    FiSend,
    FiKey,
    FiSearch,
    FiCode,
    FiCloud,
    FiCheck,
    FiCompass,
    FiFeather,
    FiHelpCircle,
    FiLifeBuoy,
    FiPackage,
    FiPhoneCall,
    FiPieChart,
    FiPlayCircle,
    FiRadio,
    FiShare2,
    FiSliders,
    FiTag,
    FiTerminal,
    FiTool,
    FiTv,
    FiUnlock,
    FiUploadCloud,
    FiUserCheck,
    FiWifi,
    FiBriefcase,
    FiBookOpen,
    FiBox,
    FiEye,
    FiMonitor,
    FiImage
} from 'react-icons/fi';

export const ICON_MAP = {
    // Technology & Systems
    'fizap': FiZap,
    'zap': FiZap,
    'ficpu': FiCpu,
    'cpu': FiCpu,
    'fidatabase': FiDatabase,
    'database': FiDatabase,
    'fiserver': FiServer,
    'server': FiServer,
    'ficloud': FiCloud,
    'cloud': FiCloud,
    'ficode': FiCode,
    'code': FiCode,
    'fiterminal': FiTerminal,
    'terminal': FiTerminal,
    'fimonitor': FiMonitor,
    'monitor': FiMonitor,
    'fismartphone': FiSmartphone,
    'smartphone': FiSmartphone,
    'fiwifi': FiWifi,
    'wifi': FiWifi,

    // Security & Safety
    'fishield': FiShield,
    'shield': FiShield,
    'filock': FiLock,
    'lock': FiLock,
    'fikey': FiKey,
    'key': FiKey,
    'fiunlock': FiUnlock,
    'unlock': FiUnlock,

    // Healthcare & Medical
    'fiactivity': FiActivity,
    'activity': FiActivity,
    'fiheart': FiHeart,
    'heart': FiHeart,
    'lifebuoy': FiLifeBuoy,
    'filifebuoy': FiLifeBuoy,

    // Business & Growth
    'fitrendingup': FiTrendingUp,
    'trendingup': FiTrendingUp,
    'fibriefcase': FiBriefcase,
    'briefcase': FiBriefcase,
    'fipiechart': FiPieChart,
    'piechart': FiPieChart,
    'fiaward': FiAward,
    'award': FiAward,
    'fiusers': FiUsers,
    'users': FiUsers,
    'fiusercheck': FiUserCheck,
    'usercheck': FiUserCheck,

    // Operations & Features
    'ficheckcircle': FiCheckCircle,
    'checkcircle': FiCheckCircle,
    'ficheck': FiCheck,
    'check': FiCheck,
    'fistar': FiStar,
    'star': FiStar,
    'fisettings': FiSettings,
    'settings': FiSettings,
    'fisliders': FiSliders,
    'sliders': FiSliders,
    'figlobe': FiGlobe,
    'globe': FiGlobe,
    'filayers': FiLayers,
    'layers': FiLayers,
    'fipackage': FiPackage,
    'package': FiPackage,
    'fibox': FiBox,
    'box': FiBox,
    'figrid': FiGrid,
    'grid': FiGrid,
    'fifiletext': FiFileText,
    'filetext': FiFileText,
    'fifolder': FiFolder,
    'folder': FiFolder,
    'ficlock': FiClock,
    'clock': FiClock,
    'fitag': FiTag,
    'tag': FiTag,
    'fitool': FiTool,
    'tool': FiTool,
    'fisearch': FiSearch,
    'search': FiSearch,
    'fieye': FiEye,
    'eye': FiEye,
    'fiimage': FiImage,
    'image': FiImage,
    'ficompass': FiCompass,
    'compass': FiCompass,
    'fibookopen': FiBookOpen,
    'bookopen': FiBookOpen,
};

export const AVAILABLE_REACT_ICONS = [
    { name: 'FiZap', label: 'Tốc độ / Sấm sét', category: 'Tech' },
    { name: 'FiCpu', label: 'Vi xử lý / AI', category: 'Tech' },
    { name: 'FiDatabase', label: 'Cơ sở dữ liệu', category: 'Tech' },
    { name: 'FiServer', label: 'Máy chủ / Hạ tầng', category: 'Tech' },
    { name: 'FiCloud', label: 'Điện toán đám mây', category: 'Tech' },
    { name: 'FiCode', label: 'Lập trình / API', category: 'Tech' },
    { name: 'FiMonitor', label: 'Màn hình / Desktop', category: 'Tech' },
    { name: 'FiSmartphone', label: 'Ứng dụng di động', category: 'Tech' },
    { name: 'FiWifi', label: 'Mạng / IoT', category: 'Tech' },
    { name: 'FiShield', label: 'Bảo mật / An toàn', category: 'Security' },
    { name: 'FiLock', label: 'Mã hóa / Khóa', category: 'Security' },
    { name: 'FiKey', label: 'Khóa bảo mật', category: 'Security' },
    { name: 'FiActivity', label: 'Y tế / Nhịp tim', category: 'Medical' },
    { name: 'FiHeart', label: 'Chăm sóc sức khỏe', category: 'Medical' },
    { name: 'FiLifeBuoy', label: 'Cấp cứu / Hỗ trợ', category: 'Medical' },
    { name: 'FiTrendingUp', label: 'Tăng trưởng / Hiệu năng', category: 'Business' },
    { name: 'FiBriefcase', label: 'Doanh nghiệp / Quản lý', category: 'Business' },
    { name: 'FiPieChart', label: 'Thống kê / Báo cáo', category: 'Business' },
    { name: 'FiAward', label: 'Chứng nhận / Giải thưởng', category: 'Business' },
    { name: 'FiUsers', label: 'Người dùng / Đội ngũ', category: 'Business' },
    { name: 'FiUserCheck', label: 'Xác thực người dùng', category: 'Business' },
    { name: 'FiCheckCircle', label: 'Đạt chuẩn / Hoàn thành', category: 'General' },
    { name: 'FiStar', label: 'Nổi bật / Ưu tiên', category: 'General' },
    { name: 'FiSettings', label: 'Cấu hình / Tùy biến', category: 'General' },
    { name: 'FiSliders', label: 'Điều khiển thông minh', category: 'General' },
    { name: 'FiGlobe', label: 'Toàn cầu / Kết nối', category: 'General' },
    { name: 'FiLayers', label: 'Kiến trúc / Phân tầng', category: 'General' },
    { name: 'FiPackage', label: 'Gói giải pháp', category: 'General' },
    { name: 'FiGrid', label: 'Module / Hệ sinh thái', category: 'General' },
    { name: 'FiFileText', label: 'Bệnh án / Hồ sơ', category: 'General' },
    { name: 'FiClock', label: 'Thời gian thực (Real-time)', category: 'General' },
    { name: 'FiTag', label: 'Huy hiệu / Nhãn', category: 'General' },
    { name: 'FiTool', label: 'Công cụ tiện ích', category: 'General' },
    { name: 'FiCompass', label: 'Định hướng / Tầm nhìn', category: 'General' },
    { name: 'FiBookOpen', label: 'Đào tạo / Hướng dẫn', category: 'General' },
];

export const POPULAR_EMOJIS = [
    '⚡', '🛡️', '📊', '🏥', '🔒', '🚀', '💊', '💡', '🩺', '📱',
    '🌐', '🏆', '✨', '📈', '⚙️', '🎯', '🤝', '🌟', '⏱️', '📋',
    '💻', '🧬', '🔬', '🚑', '💉', '💼', '🔥', '✅', '👑', '🌈'
];

const DynamicIcon = ({
    icon,
    size = 22,
    className = '',
    style = {}
}) => {
    if (!icon) return null;

    const trimmed = String(icon).trim();
    const cleanKey = trimmed.toLowerCase().replace(/[^a-z0-9]/g, '');

    const IconComp = ICON_MAP[cleanKey];

    if (IconComp) {
        return <IconComp size={size} className={`dynamic-react-icon ${className}`} style={style} />;
    }

    // Check if it's an emoji or plain text badge
    return (
        <span className={`dynamic-icon-text ${className}`} style={{ fontSize: size, ...style }}>
            {trimmed}
        </span>
    );
};

export default DynamicIcon;
